import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, API } from "@/lib/api";
import { useApp } from "@/context/AppContext";
import { Brand, TopControls } from "@/components/Nav";
import Footer from "@/components/Footer";
import { openCookiePreferences } from "@/components/CookieBanner";
import { Button } from "@/components/ui/button";
import { Download, Loader2 } from "lucide-react";

function fill(text, c) {
  if (!c) return text;
  return (text || "")
    .replaceAll("{{ragione_sociale}}", c.ragione_sociale || "")
    .replaceAll("{{legal_address}}", c.legal_address || "")
    .replaceAll("{{vat_code}}", c.vat_code || "")
    .replaceAll("{{support_email}}", c.support_email || "");
}

export default function LegalPage({ docType }) {
  const { lang } = useApp();
  const L = (it, en) => (lang === "en" ? en : it);
  const nav = useNavigate();
  const [doc, setDoc] = useState(null);
  const [company, setCompany] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    Promise.all([api.get(`/legal/${docType}`), api.get("/company")])
      .then(([d, c]) => { setDoc(d.data); setCompany(c.data); })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [docType]);

  return (
    <div className="min-h-screen flex flex-col">
      <div className="max-w-3xl w-full mx-auto px-6 sm:px-10 py-8 flex-1">
        <div className="flex items-center justify-between mb-8">
          <Brand onClick={() => nav("/")} /><TopControls />
        </div>
        {loading ? (
          <div className="py-20 text-center text-muted-foreground"><Loader2 className="w-6 h-6 animate-spin inline" /></div>
        ) : doc ? (
          <article data-testid={`legal-${docType}`}>
            <div className="flex items-start justify-between gap-4 mb-2">
              <h1 className="text-3xl font-bold">{doc.title}</h1>
              <a href={`${API}/legal/${docType}/pdf`} target="_blank" rel="noreferrer">
                <Button variant="outline" size="sm" data-testid={`legal-pdf-${docType}`}><Download className="w-4 h-4 mr-1" />PDF</Button>
              </a>
            </div>
            <p className="text-xs text-muted-foreground mb-8">
              {L("Versione", "Version")} v{doc.version} · {L("Ultimo aggiornamento", "Last updated")} {(doc.updated_at || "").slice(0, 10)}
            </p>
            <div className="space-y-7">
              {(doc.sections || []).map((s, i) => (
                <section key={i}>
                  {s.heading ? <h2 className="text-lg font-semibold mb-2">{s.heading}</h2> : null}
                  <p className="text-sm leading-relaxed text-muted-foreground whitespace-pre-wrap">{fill(s.body, company)}</p>
                </section>
              ))}
            </div>
          </article>
        ) : (
          <p className="text-muted-foreground">{L("Documento non disponibile.", "Document not available.")}</p>
        )}
      </div>
      <Footer onOpenCookiePrefs={openCookiePreferences} />
    </div>
  );
}
